module.exports = __webpack_public_path__ + "static/media/8D.d0fe532e.svg";